var App = App || {};

App.SpeedBump = (function () {
    'use strict';

    const SPEEDBUMP_SELECTOR = "#SpeedBump";
    const SMART_BANNER_SELECTOR = ".smartbanner";
    let currentAnchor = null;
    let triggeredByModal = null;
    let triggeredByElement = null;
    let triggeredByEventType = null;

    // Initializes the speed bump modal for the given anchor
    const initialize = (anchor) => {

        const speedBumpElement = document.querySelector(SPEEDBUMP_SELECTOR);
        if (!speedBumpElement || !requiresSpeedBump(anchor)) return false;

        // a speed bump is already opening or open; swallow the click rather than let the link through
        if (currentAnchor) return true;

        // reuse the one instance; a new Modal per click stacks duplicate handlers on the element
        const speedBumpModal = bootstrap.Modal.getOrCreateInstance(speedBumpElement);

        currentAnchor = anchor;
        checkModalParent(anchor);
        setProceedButton(speedBumpElement, speedBumpModal, anchor);

        // { once: true }: these listeners belong to this click only, so they don't pile up and refocus older links
        speedBumpElement.addEventListener("hide.bs.modal", () => releaseFocus(speedBumpElement), { once: true });
        speedBumpElement.addEventListener("hidden.bs.modal", restoreFocus, { once: true });

        // wait for the parent to finish hiding; its cleanup would otherwise unlock page scroll under the speed bump
        if (triggeredByModal) {
            triggeredByElement.addEventListener(`hidden.bs.${triggeredByEventType}`, () => speedBumpModal.show(), { once: true });
            releaseFocus(triggeredByElement);
            triggeredByModal.hide();
        }
        else {
            speedBumpModal.show();
        }

        return true;
    };

    // Reduces a hostname to a comparable form: lowercase, no trailing dot, no leading "www."
    const normalizeHostname = (hostname) => {

        const normalized = String(hostname || "").trim().replace(/\.$/, "").toLowerCase();
        return normalized.startsWith("www.") ? normalized.slice(4) : normalized;
    };

    // Determines if the speed bump modal is required for the anchor
    const requiresSpeedBump = (anchor) => {

        // the smart app banner links straight to the app stores and is never speed bumped
        if (anchor.closest(SMART_BANNER_SELECTOR)) return false;

        try {
            const url = new URL(anchor.getAttribute("href"));
            const href = url.href;
            const hostname = normalizeHostname(url.hostname);

            const exemptList = typeof SpeedbumpData !== 'undefined' ? (SpeedbumpData.ExemptList ?? []).map(normalizeHostname) : [];
            const isUriSchema = App.Helpers.isUriSchema(href);

            if (hostname === normalizeHostname(location.hostname) || exemptList.indexOf(hostname) !== -1 || isUriSchema)
                return false;

            return true;
        }
        catch (e) {
            return false;
        }
    };

    // Sets the proceed button behavior in the speed bump modal
    const setProceedButton = (speedBumpElement, speedBumpModal, anchor) => {

        const href = anchor.getAttribute("href");
        const proceedButton = speedBumpElement.querySelector("button[data-speedbump='proceed']");
        if (!proceedButton) return;

        proceedButton.onclick = () => {
            speedBumpModal.hide();
            window.open(href, "_blank", "noopener");
        };
    };

    // Moves focus out of an element before Bootstrap sets aria-hidden on it
    const releaseFocus = (element) => {

        if (element.contains(document.activeElement)) document.activeElement.blur();
    };

    // Reopens the parent modal or offcanvas, if any, and returns focus to the anchor (WCAG 2.4.3)
    const restoreFocus = () => {

        const anchor = currentAnchor;
        const parentModal = triggeredByModal;
        const parentElement = triggeredByElement;
        const parentEventType = triggeredByEventType;

        currentAnchor = null;
        triggeredByModal = null;
        triggeredByElement = null;
        triggeredByEventType = null;

        const focusAnchor = () => {
            if (anchor && anchor.isConnected) anchor.focus();
        };

        if (parentModal) {
            parentElement.addEventListener(`shown.bs.${parentEventType}`, focusAnchor, { once: true });
            parentModal.show();
        }
        else {
            focusAnchor();
        }
    };

    // Checks if the anchor is inside another modal or offcanvas and stores its instance
    const checkModalParent = (anchor) => {

        triggeredByModal = null;
        triggeredByElement = null;
        triggeredByEventType = null;

        const parentElement = anchor.closest(".modal, .offcanvas");
        if (!parentElement) return;

        const parentModal = getInstance(parentElement);
        if (!parentModal) return;

        triggeredByModal = parentModal;
        triggeredByElement = parentElement;
        triggeredByEventType = getEventType(parentElement);
    };

    const getEventType = (element) => element.classList.contains("modal") ? "modal" : "offcanvas";

    const getInstance = (element) => getEventType(element) === "modal"
        ? bootstrap.Modal.getInstance(element)
        : bootstrap.Offcanvas.getInstance(element);

    return {
        initialize,
        getTriggeredByModal: () => triggeredByModal
    };

})();